@if (deltakereSomRepresentererAksjeeiere().length > 0 || medlemmerSomIkkeRepresentererAksjeeier().length > 0) {
  <div class="antall-valgt" [ngClass]="{'antall-valgt__ingen':antallTotaltValgt() == 0}">
    <span>
      {{ "{andel} av {totalt} gruppemedlemmer deltar"|translate:{andel: antallTotaltValgt(), totalt: antallTotalt()} }}
    </span>
  </div>
  <table>
    <tr>
      <th class="valgt"></th>
      <th class="aksjeeiere-tittelrad" colspan="2">{{ "Gruppemedlem som representerer aksjonær"|translate }}</th>
      @if (skalSignereValgSynlig()) {
        <th colspan="2" class="skal-signere">{{ "Skal signere protokollen"|translate }}</th>
      } @else {
        <th>{{ "Rolle"|translate }}</th>
      }
    </tr>
    <tbody data-testid="deltakere-som-representerer-aksjeeier">
      @for (deltaker of deltakereSomRepresentererAksjeeiere(); track deltaker.medlemIdEllerInvitasjonId) {
        <moete-rediger-deltaker-gf [skjema]="deltaker.deltakerEllerInvitasjon" [aksjeeiere]="deltaker.aksjeeiere" [skalSignereValgSynlig]="skalSignereValgSynlig()"/>
      }
    </tbody>
    @if (antallAksjeeiereUtenRepresentantTildelt() > 0) {
      <tr>
        <td colspan="4" class="ikke-alle-aksjeeiere-har-representant">
          <inline-melding type="advarsel" voksHorisontalt="true">
            <div>{{ '{antall} aksjeposter mangler representant.'|translate:{antall: antallAksjeeiereUtenRepresentantTildelt()} }}</div>
            <a (click)="gaaTilRepresentasjonSteg()">{{ 'Klikk her for å velge hvem som skal representere aksjepostene.'|translate }}</a>
          </inline-melding>
        </td>
      </tr>
    }
    <tr>
      <th class="valgt">
        <mat-checkbox (click)="endreAlleSomIkkeReprAksjeeier()"
                      [indeterminate]="!alleSomIkkeReprAksjeeierValgt() && !ingenSomIkkeReprAksjeeierValgt()"
                      [checked]="alleSomIkkeReprAksjeeierValgt()"
                      matTooltip="{{'Velg alle eller ingen medlemmer'|translate}}"/>
      </th>
      <th class="valgt-tittelrad" colspan="2" (click)="endreAlleSomIkkeReprAksjeeier()" matTooltip="{{'Velg alle eller ingen medlemmer'|translate}}">{{ "Øvrige gruppemedlemmer"|translate }}</th>
      @if (skalSignereValgSynlig()) {
        <th colspan="2" class="skal-signere"></th>
      } @else {
        <th></th>
      }
    </tr>
    <tbody data-testid="deltakere-som-ikke-representerer-aksjeeier">
      @for (deltakerSkjema of medlemmerSomIkkeRepresentererAksjeeier(); track deltakerSkjema.value.medlem!.id; ) {
        <moete-rediger-deltaker [skjema]="deltakerSkjema" [skalSignereValgSynlig]="skalSignereValgSynlig()"/>
      }
    </tbody>
  </table>

} @else {
  <tips>
    <span>{{ "Gruppen inneholder ingen medlemmer"|translate }} <!--@todo lage en bedre melding-->.</span>
  </tips>
}
